import { render, staticRenderFns } from "./SkipButton.vue?vue&type=template&id=637ea875&scoped=true"
var script = {}
import style0 from "./SkipButton.vue?vue&type=style&index=0&id=637ea875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637ea875",
  null
  
)

export default component.exports